import { useState } from "react";
import { Loader2, Send, Sparkles } from "lucide-react";
import { createDecodeRequest } from "@/lib/api";
import { toast } from "sonner";

export default function DecodeRequestForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!name.trim() || !email.trim() || !text.trim()) {
      toast.error("Fill in all three fields — the decode needs somewhere to go.");
      return;
    }
    setSending(true);
    try {
      await createDecodeRequest({ name, email, request_text: text });
      setSent(true);
      setName(""); setEmail(""); setText("");
      toast.success("Request sent — check your email for a reply.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to send request — try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="rise rise-2 panel p-6 md:p-8" data-testid="decode-request-panel">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-sm border border-[rgba(212,175,55,0.4)] flex items-center justify-center shrink-0">
          <Sparkles className="gold" size={18} />
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] gold">// Commission</div>
          <div className="font-display text-lg text-white mt-0.5">Do me a decode</div>
        </div>
      </div>

      <p className="muted text-sm leading-relaxed mb-2">
        Want a name, date, event or headline decoded properly? Send it through — I'll reply
        by email and we'll agree a price. Payment goes through the PayPal link above.
      </p>
      <div className="border border-white/10 bg-black/20 px-4 py-3 mb-5 font-mono text-[11px] muted leading-relaxed" data-testid="decode-request-policy">
        <span className="gold">The deal:</span> don't like your decode → money back, no drama.
        But <span className="text-white">three refunds and you're out</span> — that email can't
        request again. Fair's fair.
      </div>

      {sent ? (
        <div className="border border-[rgba(16,185,129,0.4)] bg-[rgba(16,185,129,0.08)] px-4 py-4 text-sm" data-testid="decode-request-success">
          <span className="font-semibold" style={{ color: "#6EE7B7" }}>Request received.</span>{" "}
          <span className="muted">Keep an eye on your inbox — reply lands from thebeerguy28@gmail.com.</span>
          <button onClick={() => setSent(false)} className="block mt-2 font-mono text-[10px] uppercase tracking-wider muted hover:text-white">
            + Send another
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
              className="terminal-input px-3 py-2.5 text-sm"
              data-testid="decode-request-name"
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email (replies go here)"
              className="terminal-input px-3 py-2.5 text-sm"
              data-testid="decode-request-email"
            />
          </div>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={4}
            placeholder="What do you want decoded? Names, dates, events — the more detail the better…"
            className="terminal-input w-full px-3 py-2.5 text-sm resize-y"
            data-testid="decode-request-text"
          />
          <button
            onClick={submit}
            disabled={sending}
            className="btn-primary px-6 py-3 text-xs flex items-center justify-center gap-2 disabled:opacity-50 w-full sm:w-auto"
            data-testid="decode-request-submit"
          >
            {sending ? <Loader2 className="animate-spin" size={14} /> : <Send size={14} />}
            Request my decode
          </button>
        </div>
      )}
    </div>
  );
}
